module.exports = __webpack_public_path__ + "86e906fceba0505825764c52d90e3d31.svg";